import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyAxDiJKHMgEmZa1ljoS6ueemrjenBaAhYM",
  authDomain: "jadalnia-d3bcb.firebaseapp.com",
  databaseURL: "https://jadalnia-d3bcb.firebaseio.com",
  projectId: "jadalnia-d3bcb",
  storageBucket: "jadalnia-d3bcb.appspot.com",
  messagingSenderId: "549776333674"
};
firebase.initializeApp(config);

export const db = firebase.firestore()
